module.exports = __webpack_public_path__ + "img/imgsure2.ba0e696d.png";